// Copied from @yealink_dev/yealink-node-sdk-rcc/dist/main/common-types.d.ts, without importing the package into the web app

export enum DeviceBtnType {
  Undefined = 0,
  OffHook = 1,
  Mute = 2,
  Flash = 3,
  Hold = 4,
  Redial = 5,
  Line = 6,
  SpeakerPhone = 7,
  Send = 8,
  Reject = 9,
  SpeedDial = 10,
  VoiceMail = 11,
  LedRinger = 12,
  LineBusyTone = 13,
  Key0 = 14,
  Key1 = 15,
  Key2 = 16,
  Key3 = 17,
  Key4 = 18,
  Key5 = 19,
  Key6 = 20,
  Key7 = 21,
  Key8 = 22,
  Key9 = 23,
  KeyStar = 24,
  KeyPound = 25,
  KeyDelete = 26,
  KeyVolumeUp = 27,
  KeyVolumeDown = 28,
  KeyFastForward = 29,
  KeyRewind = 30,
  KeyScanNextTrack = 31,
  KeyScanPreviousTrack = 32,
  KeyStop = 33,
  KeyPlayPause = 34,
}
/**
 * Device description structure, identifies attached devices.
 */
export interface DeviceInfo {
  deviceId: number
  productId: number
  vendorId: number
  deviceName: string
  devicePath: string
  isDongle: boolean
  dongleName: string
  variant: string
  serialNumber: string
  isInFirmwareUpdateMode: boolean
  connectionId: number
  parentDeviceId: number
}
export enum BusylightStatus {
  BUSYLIGHT_UNKNOWN = 0,
  BUSYLIGHT_RING = 1,
  BUSYLIGHT_TALKING = 2,
  BUSYLIGHT_HOLD = 3,
  BUSYLIGHT_MUTE = 4,
  BUSYLIGHT_DIALINNG = 5,
  BUSYLIGHT_ONLINE = 6,
  BUSYLIGHT_OFFLINE = 7,
  BUSYLIGHT_LEFT = 8,
  BUSYLIGHT_BUSY = 9,
  BUSYLIGHT_NOT_DISTURB = 10,
  BUSYLIGHT_OFFWORK = 11,
}
export enum AudioModes {
  AM_HANDFREE = 0,
  AM_HEADSET = 1,
}
export interface ContactInfo {
  name: string
  number: string
}
export enum CallAction {
  CALL_ACTION_ACCEPT = 1,
  CALL_ACTION_TERMINATE = 2,
  CALL_ACTION_HOLD = 3,
  CALL_ACTION_RESUME = 4,
  CALL_ACTION_REJECT = 5,
  CALL_ACTION_CALL_OUT = 6,
  CALL_ACTION_ENTER_DIAL = 7,
  CALL_ACTION_MUTE = 8,
  CALL_ACTION_UNMUTE = 9,
  CALL_ACTION_DTMF = 10,
  CALL_ACTION_REDIAL = 11,
}
